// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from './Modal';
import listdir from '../../utilities/listdir';
import SelectStack from '../SelectStack';

import { toast } from 'react-toastify';

import '../../styles/move.css';


export default class MoveStack extends Modal {

    state = {
        root: "",
        children: [],
        hoverIndicator: {},
        selectedStack: "",
        selectedStackPath: "",
    }

    hoverTimeout = {}
    hoverIndicator = {}

    componentDidMount = () => {
        // Get parent path
        // Set the selected stack to the current stack 
        this.state.selectedStack = this.props.stack._id?? "Root"; 
        this.state.selectedStackPath = this.props.stack.path??"";
        this.setNodeChildren(this.props.stacks, this.props.stack.path??"");
    }

    getParentPath = (path) => {
        const pathCmp = path.split("/");
        pathCmp.pop();
        return pathCmp.join("/");
    }

    getStackByPath = (path) => {
        return this.props.stacks.find(s => s.path === path);
    }

    getStackById = (id) => {
        return this.props.stacks.find(s => s._id === id);
    }

    setNodeChildren = (stacks, parent) => {
        let root = parent;
        let children = listdir(stacks, root);
        // Navigate up until we have at least one child or we hit the root
        while (children.length === 0 && root !== "") {
            root = this.getParentPath(root);
            children = listdir(stacks, root);
        }

        // For all children, check if there are nested stacks
        for (const child of children) {
            const grandchildren = stacks.filter(s => s.path.substring(0, child.path.length+1) === child.path+"/");
            child.hasChildren = grandchildren.length > 1;
        }

        this.setState({
            root,
            children
        });
    }

    handleSubmit = (stack) => {
        // Check if user is trying to move stack into itself
        const currentPath = this.props.stacks.find((stack)=>stack._id === this.props.data)?.path

        if (currentPath === this.state.selectedStackPath)
            return toast.error("You cannot move stack into itself")

        if(this.props.stack._id === this.state.selectedStack || !this.state.selectedStack)
            return toast.error('You must select a new stack to move the stack into')

        this.props.move(stack, this.state.selectedStack === "Root"? "": this.state.selectedStackPath);
    }

    renderContent = () => {

        const target = this.props.data;

        return (<div
            className={"modal-content modal-center"}
        >

            <h1>Move your stack</h1>

            <p>
                Select the stack you'd like to move them inside.
            </p>

            <div style={{ clear: 'both' }} />

            <SelectStack
                value={this.state.selectedStack? this.state.selectedStack: ""}
                onChange={selectedStack => {
                    const selectedStackPath = this.props.stacks.find((stack)=>stack._id === selectedStack)?.path; 
                    this.setState({selectedStack: selectedStack, selectedStackPath: selectedStackPath})
                }}
                stacks={[{_id: "Root", path: "My Stacks Root"}, ...this.props.stacks]}
                currentStackId={this.props.data}
            />

            <div style={{ clear: 'both'}} />

            <div
                className="button"
                style={{
                    float: 'none',
                    backgroundImage: "url('https://static.stax.ai/images/icons/reviewed.png')",
                    marginTop: 16
                }}
                onClick={() => this.handleSubmit(this.getStackById(target))}
            >
                Move Stack
            </div>
            
        </div>);
    }
};